import { c as _c } from "react/compiler-runtime";
import React, { useRef, useState, useEffect, useLayoutEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useDebounce } from 'react-use';
import { Helmet } from 'react-helmet-async';
import { CYLINDO_ACCOUNT_ID } from 'commons/constants';
import buildCylindoFrameOneUrl from 'commons/buildCylindoFrameOneUrl';
import usePdpId from '../state/context/usePdpId';
const SCRIPT_ID = 'cylindoScript';
const loadCylindo = callback => {
  const existingScript = document.getElementById(SCRIPT_ID);
  if (!existingScript) {
    const script = document.createElement('script');
    script.src = 'https://viewer-cdn.cylindo.com/v1/index.mjs';
    script.id = SCRIPT_ID;
    script.type = 'module';
    script.async = true;
    document.body.appendChild(script);
    script.onload = () => {
      if (callback) callback();
    };
  } else if (callback) {
    callback();
  }
};
const PDPCylindo3dViewer = t0 => {
  const $ = _c(30);
  const {
    containerId: t1,
    cylindoFeatures,
    isMobile,
    rotateIndex
  } = t0;
  const containerId = t1 === undefined ? "PDPCylindo3dViewer" : t1;
  const containerRef = useRef(null);
  const [isReady, setIsReady] = useState(false);
  const controls = isMobile ? "ar" : "ar zoom";
  const productId = usePdpId();
  let t2;
  if ($[0] !== cylindoFeatures || $[1] !== productId) {
    t2 = () => {
      if (productId && Object.keys(cylindoFeatures).length > 0) {
        loadCylindo(() => {
          setIsReady(true);
        });
      }
    };
    $[0] = cylindoFeatures;
    $[1] = productId;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== cylindoFeatures || $[4] !== productId) {
    t3 = [productId, cylindoFeatures];
    $[3] = cylindoFeatures;
    $[4] = productId;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  useDebounce(t2, 100, t3);
  let t4;
  let t5;
  if ($[6] !== containerId || $[7] !== isMobile || $[8] !== isReady || $[9] !== rotateIndex) {
    t4 = () => {
      if (!isMobile && containerRef.current && rotateIndex >= 0 && isReady) {
        const viewer = document.querySelector(`cylindo-viewer#${containerId}`);
        if (viewer && typeof viewer.animateToFrame === "function") {
          if (rotateIndex === 0) {
            viewer.animateToFrame(1);
          } else {
            if (rotateIndex === 1) {
              viewer.animateToFrame(4);
            } else {
              if (rotateIndex === 2) {
                viewer.animateToFrame(9);
              } else {
                if (rotateIndex === 3) {
                  viewer.animateToFrame(14);
                } else {
                  if (rotateIndex === 4) {
                    viewer.animateToFrame(17);
                  }
                }
              }
            }
          }
        }
      }
    };
    t5 = [containerRef, isMobile, rotateIndex, isReady, containerId];
    $[6] = containerId;
    $[7] = isMobile;
    $[8] = isReady;
    $[9] = rotateIndex;
    $[10] = t4;
    $[11] = t5;
  } else {
    t4 = $[10];
    t5 = $[11];
  }
  useEffect(t4, t5);
  let t6;
  let t7;
  if ($[12] !== cylindoFeatures || $[13] !== isReady) {
    t6 = () => {
      if (containerRef.current && Object.keys(cylindoFeatures).length && isReady) {
        containerRef.current.features = cylindoFeatures;
      }
    };
    t7 = [containerRef, cylindoFeatures, isReady];
    $[12] = cylindoFeatures;
    $[13] = isReady;
    $[14] = t6;
    $[15] = t7;
  } else {
    t6 = $[14];
    t7 = $[15];
  }
  useLayoutEffect(t6, t7);
  let t8;
  if ($[16] !== cylindoFeatures || $[17] !== productId) {
    t8 = buildCylindoFrameOneUrl({
      productId,
      features: cylindoFeatures
    });
    $[16] = cylindoFeatures;
    $[17] = productId;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  const placeholderSrc = t8;
  let t9;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = [];
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  useLayoutEffect(_temp, t9);
  let t10;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Helmet><link rel="preconnect" href="https://content.cylindo.com" /></Helmet>;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== productId) {
    t11 = productId?.toString();
    $[21] = productId;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== placeholderSrc) {
    t12 = <img slot="placeholder" alt="placeholder" src={placeholderSrc} />;
    $[23] = placeholderSrc;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== containerId || $[26] !== controls || $[27] !== t11 || $[28] !== t12) {
    t13 = <>{t10}<div className="w-full !h-full ml-auto mr-auto max-md:min-h-[375px] flex justify-center items-center [&_img]:w-4/5 lg:[&_cylindo-viewer]:aspect-[1.8]" data-xc="PDPCylindo3dViewerContainer"><cylindo-viewer controls={controls} ref={containerRef} key={containerId} customer-id={CYLINDO_ACCOUNT_ID} code={t11} id={containerId} show-zoom-controls-on-touch="" data-xc="PDPCylindo3dViewer">{t12}</cylindo-viewer></div></>;
    $[25] = containerId;
    $[26] = controls;
    $[27] = t11;
    $[28] = t12;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  return t13;
};
PDPCylindo3dViewer.propTypes = {
  containerId: PropTypes.string,
  cylindoFeatures: PropTypes.arrayOf(PropTypes.string),
  isMobile: PropTypes.bool,
  rotateIndex: PropTypes.number
};
export default PDPCylindo3dViewer;
function _temp() {
  const viewer_0 = document.querySelector("cylindo-viewer");
  viewer_0?.addEventListener("loaded", () => {
    const {
      modelViewer
    } = viewer_0;
    if (modelViewer) {
      modelViewer.exposure = 0.9;
    }
  });
}